import { ReactivateModal } from '@presentation/components/templates'

type Props = {
  id: string
  onReactivate: () => void
}

const ReactivateEixoModal: React.FC<Props> = ({ id, onReactivate }) => {
  const modalConfigs = {
    id,
    path: '/eixos',
    nameForTitle: 'Eixo',
    onReactivate
  }

  return <ReactivateModal {...modalConfigs} />
}

export default ReactivateEixoModal
